<ng-container *sm-has-env-flag="'auroraV1'">
    <aurora-header auroraAppHeader [view]="'Conf'">
        <div slot="actions" class="d-flex align-items-center gap-2">
            <ikc-button />
            <sm-notification-icon-button></sm-notification-icon-button>
            <div class="main-menu-dropdown" (click)="$event.stopPropagation()">
                <aurora-icon-button
                    id="mainMenuButton"
                    class="main-menu-button"
                    variant="ghost"
                    size="xlarge"
                    icon="more-vertical"
                    label="Main menu"
                    (click)="toggleMainMenu($event)">
                </aurora-icon-button>
                @if (isMainMenuOpen) {
                <div class="main-menu-dropdown-panel">
                    <sm-main-menu [view]="'Conf'" (itemSelected)="isMainMenuOpen = false"></sm-main-menu>
                </div>
                }
            </div>
        </div>
    </aurora-header>
</ng-container>

<ng-container *sm-has-not-env-flag="'auroraV1'">
    <unity-header [view]="'Conf'">
        <ng-container right>
            <div class="unity-header-item">
                <ikc-button />
            </div>
            <div class="unity-header-item">
                <sm-notification-icon-button></sm-notification-icon-button>
            </div>
        </ng-container>
    </unity-header>
</ng-container>

<main>
    <router-outlet></router-outlet>
</main>
